module.exports = __webpack_public_path__ + "img/pr_influencer_image.58cf1833.png";